import { render, staticRenderFns } from "./FastFood.vue?vue&type=template&id=5e221827&"
import script from "./FastFood.vue?vue&type=script&lang=js&"
export * from "./FastFood.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports